
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function CallToAction() {
  const navigate = useNavigate();

  return (
    <section className="py-16 bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          お車のことでお困りですか？
        </h2>
        <p className="text-xl mb-8 text-gray-300 max-w-2xl mx-auto">
          車検、修理、鈑金など、どんなことでもお気軽にご相談ください。<br />
          経験豊富なスタッフが丁寧に対応いたします。
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Button 
            size="lg"
            onClick={() => navigate('/contact')}
            className="text-lg px-8 py-4"
          >
            お問い合わせ
          </Button>
          <Button 
            variant="outline" 
            size="lg"
            onClick={() => navigate('/pricing')}
            className="text-lg px-8 py-4 border-white text-white hover:bg-white hover:text-slate-800"
          >
            料金を見る
          </Button>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 text-lg">
          <div className="flex items-center">
            <i className="ri-phone-line text-2xl text-orange-400 mr-3"></i>
            <span>0120-000-000</span>
          </div>
          <div className="flex items-center">
            <i className="ri-time-line text-2xl text-orange-400 mr-3"></i>
            <span>受付時間: 9:00〜18:00</span>
          </div>
        </div>
      </div>
    </section>
  );
}
